module.exports = __webpack_public_path__ + "img/logo-white.b28292a8.png";